.versionSelect {
  margin-left: 16px;
  margin-right: 16px;
}
